import { reports as reportsRoute } from '../../../data/enums/Route';
import { getFilterConfig } from '../../../utils/filter';
import { FILTER } from '../../../data/enums/filter';

const title = 'User Cluster';

const breadCrumb = [reportsRoute];

const filter = getFilterConfig([FILTER.DSE_TAS, FILTER.CHANNEL, FILTER.CATEGORY, FILTER.SUB_D]);

export {
  breadCrumb as breadCrumbConfig, filter as filterConfig, title
};
